import axios from 'axios'
import config from '../helpers/config'

const getSlideData = (jwt: string, externalUid: string) => {
	return axios
		.request({
			method: 'get',
			url: `${config.getSlideApiGatewayPath()}/slide/game/${externalUid}/getGame`,
			headers: { authorization: `Bearer ${jwt}` },
		})
		.then(function (response) {
			return response.data
		})
}

export default {
	getSlideData,
}
